import { useState } from "react";

import { useTranslation } from "react-i18next";
import { Grid, InputAdornment } from "@mui/material";

import BasicDialog from "../../components/base/BasicDialog";
import { ProductSelectionFormControl } from "../../components/form/ProductSelectionFormControl/ProductSelectionFormControl"
import { STATUS_KEYS } from "../../schemas/status";

import { useOfferDrafts } from "../../services/draftsService";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";

import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

import { useGenerateBlankOfferDraftMutation } from "../../services/draftsService";
import { openPdfPreview } from "../SalesDraftsPage/DraftPreview/openPdfPreview";

export function OfferPreviewDialog(props) {
    const { t } = useTranslation();

    const [selectedProductIds, setSelectedProductIds] = useState([])
    const [selectedDraft, setSelectedDraft] = useState()
    const [discount, setDiscount] = useState()

    const { data: offerDraftsResponse, isLoading: loadingDrafts } = useOfferDrafts();
    const offerDrafts = (offerDraftsResponse?.results || []).filter((draft) => draft.active);

    const { mutate: generatePdf, isPending } = useGenerateBlankOfferDraftMutation({
            onSuccess: (response) => openPdfPreview(response.data),
        });
    
    const handlePreview = () => {
        generatePdf({
            draftId: selectedDraft,
            requestBody: { discount: discount, product_ids: selectedProductIds },
        });
    };

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign="center"
            contentAlign="start"
            title={t("offers.generateOffer")}
            alwaysFullScreen={true}
            // maxWidth="lg"
            showDialogActions={false}
        >
            <LoaderWrapper showLoader={loadingDrafts}>
                <Grid container columnSpacing={3}>
                    <Grid item xs={12}>
                        <ProductSelectionFormControl
                            multipleApartments={true}
                            selectedProductIds={selectedProductIds}
                            setSelectedProductIds={setSelectedProductIds}
                            readOnly={false}
                            excludedStatuses={[
                                STATUS_KEYS.Sold,
                                STATUS_KEYS.Reservation,
                            ]}
                        />
                    </Grid>
                    <Grid item xs={6} />
                    <Grid item xs={3} sx={{marginLeft: -1}}>
                    <FormControl fullWidth>
                        <InputLabel id={"draft_select"}>
                            {t("offers.selectDraft")}*
                        </InputLabel>
                        <Select
                            labelId={"draft_select"}
                            value={selectedDraft || ""}
                            label={`${t("offers.selectDraft")}*`}
                            onChange={(event) => {
                                const draftId = event.target.value;
                                setSelectedDraft(draftId)
                            }}
                        >
                            {offerDrafts.map((draft) => (
                                <MenuItem key={draft.id} value={draft.id}>
                                    {draft.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    </Grid>
                    <Grid item xs={3}> 
                        <TextField
                            fullWidth
                            type="number"
                            // variant={"outlined"}
                            label={t("offers.product_discount")}
                            value={discount}
                            sx={{ minWidth: "100px"}}
                            onChange={(e) => {
                                const fieldValue = e.target.value === "" ? "" : Number.parseFloat(e.target.value)
                                setDiscount(fieldValue)
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">%</InputAdornment>

                            }}
                            inputProps={
                                { min: 0, max: 100, step: 0.01 }
                            }
                        />
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item xs={6} />
                        <Grid item xs={6}>
                        <LoadingButton
                            sx={{marginTop:2}}
                            startIcon={<RemoveRedEyeOutlinedIcon />}
                            fullWidth
                            variant="contained"
                            onClick={handlePreview}
                            disabled={!selectedDraft}
                            loading={isPending}
                        >
                            {t("offers.generate")}
                        </LoadingButton>
                        </Grid>
                    </Grid>
                </Grid>
            </LoaderWrapper>
        </BasicDialog>
    );
}
